import { gql } from '@apollo/client';

export const USER_LOG_IN_MUTATION = gql`
  mutation signIn($login: String!, $password: String!) {
    signIn(login: $login, password: $password) {
      session {
        user {
          id
          roles {
            id
            name
          }
        }
        accessToken
        refreshToken
        refreshTokenExpiresAt
        mfaEnabled
        needPasswordUpdate
      }
    }
  }
`;

export const USER_CHECK_MFA_CODE_MUTATION = gql`
  mutation checkMfaCode($login: String!, $mfaCode: String!) {
    checkMfaCode(login: $login, mfaCode: $mfaCode) {
      session {
        user {
          id
        }
        accessToken
        refreshToken
        refreshTokenExpiresAt
        needPasswordUpdate
      }
    }
  }
`;

export const USER_RESEND_MFA_CODE_MUTATION = gql`
  mutation resendMfaCode($login: String!) {
    resendMfaCode(login: $login) {
      success
    }
  }
`;

export const USER_LOG_OUT_MUTATION = gql`
  mutation signOut {
    signOut {
      successful
    }
  }
`;

export const CREATE_USER_MUTATION = gql`
  mutation createUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $login: String
    $timezoneId: Int
    $roleIds: [Int!]!
    $filteringRuleGroupIds: [Int!]
    $active: Boolean
    $isThirdPartyUser: Boolean
  ) {
    createUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      login: $login
      timezoneId: $timezoneId
      roleIds: $roleIds
      filteringRuleGroupIds: $filteringRuleGroupIds
      active: $active
      isThirdPartyUser: $isThirdPartyUser
    ) {
      user {
        id
        lastName
        firstName
        email
        active
        isThirdPartyUser
      }
    }
  }
`;

export const EDIT_USER_MUTATION = gql`
  mutation editUser(
    $id: Int!
    $firstName: String!
    $lastName: String!
    $email: String!
    $login: String
    $timezoneId: Int
    $roleIds: [Int!]!
    $filteringRuleGroupIds: [Int!]!
    $active: Boolean
    $isThirdPartyUser: Boolean
  ) {
    editUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      login: $login
      timezoneId: $timezoneId
      roleIds: $roleIds
      filteringRuleGroupIds: $filteringRuleGroupIds
      active: $active
      isThirdPartyUser: $isThirdPartyUser
    ) {
      user {
        id
        lastName
        firstName
        email
        active
      }
    }
  }
`;

export const USER_UPDATE_TOKENS_MUTATION = gql`
  mutation updateTokens {
    updateTokens {
      session {
        user {
          id
          roles {
            id
            name
          }
        }
        accessToken
        refreshToken
        refreshTokenExpiresAt
      }
    }
  }
`;
